define('settingsReader',['jsonReader'], function (jsonReader) {

    function readTemplateSettings() {
        return jsonReader.read('settings.js?v=1428580677492');
    }

    function readPublishSettings() {
        return jsonReader.read('publishSettings.js?v=1428580677492');
    }

    return {
        readTemplateSettings: readTemplateSettings,
        readPublishSettings: readPublishSettings
    };

});
